import _Tree from './Tree';

import './style/index.js';

export type { TreeProps } from './Tree';
export * from './type';

export const Tree = _Tree;
export default Tree;
